export default __webpack_public_path__ + "media/images/front/municipality_collaboration/car-2e99d9ae13df6ec3ba7959cdfbfa0349.png";